export default __webpack_public_path__ + "static/Group 141-b4d262ddea46229138c54c289641b368.png";